class BpSlider {

	constructor(sel) {
		// view
		this.components = document.querySelectorAll(sel);
		this.sel = sel;
		this.sliders = {};

		if (this.components.length) {
			this.init();
		}
	}

	updateOverlapContent = async (nextSlide, _slider, overlapContent) => {
		if (!nextSlide) return;
		const template = nextSlide.querySelector('.slide-overlap');

		if (template) {
			overlapContent.classList.toggle('loading', true);
			await this.sleep(500);
			const content = template.content.cloneNode(true);
			overlapContent.innerHTML = '';
			overlapContent.appendChild(content);
			overlapContent.classList.toggle('loading', false);
		}

	}


	init() {
		this.components.forEach((comp, i) => {
			let slider = comp.querySelector('.splide');
			const overlapContent = comp.querySelector('.splide > .slide-overlap');
			const _slider = new Splide(slider);

			const counter = comp.querySelector('.counter');

			if (counter) {
				const count = comp.querySelectorAll('.splide__slide').length;
				comp.querySelector('#length').innerHTML = count;
			}


			const onMove = async (i, prev) => {

				_slider.root.dataset.index = i;
				_slider.root.dataset.status = 'move';
				const nextSlide = _slider.Components.Slides.getAt(i)?.slide || null;

				if (counter) {
					counter.querySelector('#index').innerHTML = i + 1;
				}

				requestAnimationFrame(() => {
					nextSlide?.classList?.toggle('focused', true);
					if (prev){
						_slider.Components.Slides.getAt(prev)?.slide?.classList?.toggle('focused', false);
					}

				})

				this.updateOverlapContent(nextSlide, _slider, overlapContent, prev);
				await this.sleep(500)

			}

			if (overlapContent) {



				_slider.on('move', onMove)

				_slider.on('moved', async (i, prev) => {
					_slider.root.dataset.status = 'moved';


				})

				_slider.on('ready', () => {
					comp.querySelector('.splide__slide').classList.toggle('focused', true);
					const nextSlide = _slider.Components.Slides.getAt(0).slide;
					this.updateOverlapContent(nextSlide, _slider, overlapContent);

					if (counter) {
						counter.querySelector('#index').innerHTML = 1;
					}
				})
			}

			slider.id = 'slide-' + i;

			_slider.mount();

			onMove(0);
			// _slider.go(1)
			// _slider.go(0);
			// setTimeout(() => {
			// 	_slider.go(0);
			// }, 20);
			this.sliders[slider.id] = _slider;
		})

	}
	sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

}

document.addEventListener('DOMContentLoaded', e => globalThis.BP_SLIDER = new BpSlider('.bp-slider'))
